import { render } from "./j-more.vue?vue&type=template&id=2ccec287"
import script from "./j-more.vue?vue&type=script&lang=js"
export * from "./j-more.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jiangwen/GitHub/xiamao-mall/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__